import { createContext, type PropsWithChildren, useContext } from "react";

export interface PrefetchOptions {
  cacheFor?: string | [string, string];
  cacheTags?: string | string[];
}

export type PrefetchTrigger = "hover" | "click" | "mount";

export interface PrefetchProps {
  prefetch?: boolean | PrefetchTrigger | PrefetchTrigger[];
  cacheFor?: PrefetchOptions["cacheFor"];
  cacheTags?: PrefetchOptions["cacheTags"];
}

export type PrefetchFn = (href: string, options?: PrefetchOptions) => void;

const noopPrefetch: PrefetchFn = () => {};

const PrefetchContext = createContext<PrefetchFn>(noopPrefetch);

export interface PrefetchProviderProps extends PropsWithChildren {
  prefetch: PrefetchFn;
}

export function PrefetchProvider({ prefetch, children }: PrefetchProviderProps) {
  return <PrefetchContext.Provider value={prefetch}>{children}</PrefetchContext.Provider>;
}

export function usePrefetch(): PrefetchFn {
  return useContext(PrefetchContext);
}
